<template>
  <b-modal
    id="modal-1"
    centered
    v-model="$store.getters.isInactive"
    @show="handleShow"
    @hide="handleClose"
  >
    <template #modal-header class="test">
      <GradientHeading>Are you still there?</GradientHeading>
    </template>

    <h4 class="text-center">Attention</h4>
    <p class="text-center">
      you will be logged out in {{ timeRemaining }} seconds, to continue your
      session please dismiss this alert.
    </p>

    <template #modal-footer>
      <b-container fluid class="text-center">
        <b-button variant="primary" @click="closeModal"
          >Continue Session</b-button
        >
      </b-container>
    </template>
  </b-modal>
</template>

<script>
import GradientHeading from '@/components/Elements/GradientHeading/GradientHeading'
import moment from 'moment'

export default {
  components: {
    GradientHeading
  },
  data() {
    return {
      timeRemaining: 'x',
      ticker: null
    }
  },
  methods: {
    handleShow() {
      // every second calc the time remaining
      this.ticker = setInterval(this.calcTimeRemaining, 1000)
    },
    calcTimeRemaining() {
      const unixNow = moment()
        .utc()
        .unix()
      const expiresAt =
        this.$store.state.authStore.lastActivity +
        process.env.VUE_APP_SESSION_TIMEOUT * 60
      const remaining = expiresAt - unixNow
      if (-1 < remaining) {
        this.timeRemaining = remaining
      } else {
        this.remaining = 0
      }
    },
    closeModal() {
      // handles closing the modal
      this.$store.commit('setIsInactive', false)
      // reset time remaining to it's place holder
      this.timeRemaining = 'x'
    },
    handleClose() {
      // called after the modal closes
      // inform store that user is active
      this.$store.dispatch('continueSession')
    }
  }
}
</script>
